import { render, staticRenderFns } from "./userSelector.vue?vue&type=template&id=0827f809&scoped=true&"
import script from "./userSelector.vue?vue&type=script&lang=js&"
export * from "./userSelector.vue?vue&type=script&lang=js&"
import style0 from "./userSelector.vue?vue&type=style&index=0&id=0827f809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827f809",
  null
  
)

export default component.exports